import { Injectable } from '@angular/core';
import { Componente, ComponenteDTO } from '../../models/component.interface';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { RequestService } from '../request/request';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';
import { environment } from '../../../../environments/environment';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'components/';
  url = environment.service_1 + 'all-components/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedcomponent = new BehaviorSubject<Componente | null>(null);
  selectedcomponent$ = this.selectedcomponent.asObservable();

  private components = new BehaviorSubject<Componente[]>([]);
  components$ = this.components.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setComponent(component: Componente) {
    this.selectedcomponent.next(component);
  }

  setComponents(components: Componente[]) {
    this.components.next(components);
  }

  removeComponentSelected() {
    this.selectedcomponent.next(null);
  }

  createComponent(component: ComponenteDTO) {
    return this.http.post<Componente>(this.urlPath, component).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateComponent(id: number, component: ComponenteDTO & { id: number }) {
    return this.http.put<Componente>(this.urlPath + id + '/', component).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getComponent(query: QueryGet): Observable<Pagination<Componente[]>> {
    return this.requestService.get<Componente[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getComponents(): Observable<Componente[]> {
    return this.http.get<Componente[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionComponent(component: Componente[]): OptionSelect[] {
    return component.map((item: Componente) => {
      return {
        value: item.id ?? '',
        label: item.name,
      };
    });
  }
}
